import React from 'react';
import { DeedGenerationSection } from './deedGeneration/DeedGenerationSection';
import { VestingSection } from './vesting/VestingSection';

export const TitleOwnershipDeed: React.FC = () => {
  return (
    <div className="border-t border-gray-200 py-4">
      <VestingSection />
      <DeedGenerationSection />
    </div>
  );
};
